import React, { useState } from 'react';
import { toast } from 'sonner';
import { Upload, Trash2 } from 'lucide-react';
import { uploadImage, imgSrc, inputCls, labelCls } from './smartqrApi';

export const ProductFields = ({ value, onChange, index, onRemove, testPrefix = 'product' }) => {
  const [uploading, setUploading] = useState(false);
  const set = (k, v) => onChange({ ...value, [k]: v });

  const handleImage = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try { set('image', await uploadImage(file)); } catch { toast.error('Image upload failed'); }
    setUploading(false);
  };

  return (
    <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-3" data-testid={`${testPrefix}-${index}`}>
      <div className="flex items-center justify-between">
        <p className="text-sm font-bold text-slate-700">Product / Service {index + 1}</p>
        {onRemove && (
          <button type="button" onClick={onRemove} className="text-slate-400 hover:text-red-500 p-1" data-testid={`${testPrefix}-${index}-remove`}><Trash2 className="w-4 h-4" /></button>
        )}
      </div>
      <div>
        <label className={labelCls}>Name *</label>
        <input value={value.name || ''} onChange={(e) => set('name', e.target.value)} className={inputCls} placeholder="e.g. Paneer Thali" maxLength={80} data-testid={`${testPrefix}-${index}-name`} />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className={labelCls}>Price</label>
          <input value={value.price || ''} onChange={(e) => set('price', e.target.value)} className={inputCls} placeholder="₹199" maxLength={40} data-testid={`${testPrefix}-${index}-price`} />
        </div>
        <div>
          <label className={labelCls}>Image</label>
          <label className="flex items-center gap-2 border border-dashed border-slate-300 rounded-lg px-3 py-2 text-xs text-slate-500 cursor-pointer hover:border-orange-400 bg-white">
            {value.image ? <img src={imgSrc(value.image)} alt="" className="w-7 h-7 rounded object-cover" /> : <Upload className="w-4 h-4" />}
            <span className="truncate">{uploading ? 'Uploading...' : value.image ? 'Change' : 'Upload'}</span>
            <input type="file" accept="image/*" onChange={handleImage} className="hidden" data-testid={`${testPrefix}-${index}-image`} />
          </label>
        </div>
      </div>
      <div>
        <label className={labelCls}>Short description</label>
        <input value={value.description || ''} onChange={(e) => set('description', e.target.value)} className={inputCls} placeholder="Optional, max 200 chars" maxLength={200} data-testid={`${testPrefix}-${index}-description`} />
      </div>
    </div>
  );
};
